import React, { useState } from "react";
import { Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { activateMenu } from "redux/actions";
import { useAppDispatch } from "redux/store";
type Props = {
    id:number;
    upamandal_name: string;
    basti_name: string;
    gramams_formed: number;
    total_gramas_formed:number;
    total_gramas_count:number;
    members_registered :number;
    total_basti_count:number;
    total_samithi_formed:number;
    total_basti :number;
    nagar_type:number;
    total_gramas :number;
    basti_gramam_type:string;
};
export const UpmandalSthayiReportCard: React.FC<Props> = ({id,total_basti_count,total_samithi_formed, nagar_type,total_gramas_count,total_gramas_formed,basti_name,upamandal_name,gramams_formed,basti_gramam_type,members_registered,total_basti ,total_gramas }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    // const handleCardClick = (id,basti_gramam_type,upamandal_name) => {
    //     // dispatch(activateMenu(id))
    //   localStorage.setItem("basti_gramam_type", basti_gramam_type)
    //   localStorage.setItem("upamandal_name", upamandal_name)
    //   localStorage.setItem("basti_name", basti_name)
    // if(total_gramas >0) {
    //     navigate('/gramamreports/'+id, { replace: true });
    // }else if(total_basti>0){
    //     navigate('/samithi_members/'+id, { replace: true });
    // }
    // }

    // console.log("29grmamsFormed",gramams_formed)
    // console.log("30totalgrmams",total_gramas)
    let nagarKhandaName=localStorage.getItem('nagar_khanda_name')

    return (
        <Col md={4} xl={3} xs={6} className="mb-4" >
                     <Card className=" shadow h-110 " style={{ borderLeft: "5px solid #fd803a"}}>            
                <Card.Body style={{padding :"2rem"}}> 
                    <div className="row no-gutters align-items-center">
                        <div className="col mr-2">
                            <div className="text-xl font-weight-bold text-uppercase mb-1" style={{color:"#fd803a"}}>
                           {nagarKhandaName}</div>
                            <div className=" mb-0 font-weight-bold text-gray-800"></div>
                        </div>
                        <div className=" mb-0 font-weight-bold text-gray-800">
                            {/* <i className="fas fa-clipboard-list fa-2x text-gray-300"></i> */}
                            {total_basti >0 &&
                            <p>{total_samithi_formed} Over  /{total_basti_count} Total Basthis</p>
}
                        </div>
                        <div className=" mb-0.4 font-weight-bold text-gray-800">
                            {/* <i className="fas fa-clipboard-list fa-2x text-gray-300"></i> */}
                            {total_gramas >0 &&
                 <p>{total_gramas_formed} Over  /  {total_gramas_count} Total Villages</p>}
                        </div>

                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

